import React from 'react';

export const Main = props => {
    return (
        <main className={ `application-main` }>
            { props.children }
        </main>
    );
}
 
export default Main;